import React, { useState, useEffect } from "react";
import PageSeo from "../../components/seo/PageSeo";
import { useParams } from "react-router-dom";
import { verifyEmailCall } from "../../calls";
import { useTranslation } from "react-i18next";

/* VERIFY EMAIL — design "Signal" */
export default function EmailVerify(props) {
  const { setShowModal, loader, setLoader } = props;
  const { token, uid } = useParams();
  const [successChk, setSuccessChk] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    verifyEmailCall(uid, token)
      .then(() => {
        setSuccessChk(true);
        setLoader(true);
      })
      .catch(() => {
        setSuccessChk(false);
        setLoader(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!loader) return null;

  return (
    <div className="sg-page" style={{ maxWidth: 480, minHeight: "60vh", justifyContent: "center" }}>
      <PageSeo noindex title={t("signal.verify-title")} />
      <div className="sg-panel" style={{ padding: 32, textAlign: "center" }}>
        <span className="brand-logo" style={{ fontSize: 26 }}>
          <span className="b-2fa">2FA</span><span className="b-sms">SMS</span>
        </span>
        <p className={`sg-status ${successChk ? "sg-status--ok" : "sg-status--err"}`}
           style={{ justifyContent: "center", fontSize: 13, margin: "16px 0 8px" }}>
          {successChk ? t("signal.verify-ok") : t("signal.verify-failed")}
        </p>
        <p className="sg-sub" style={{ fontSize: 14, marginBottom: 20 }}>
          {successChk ? t("overview.thankyou") : t("overview.oops")}
        </p>
        <button
          className="sg-btn sg-btn--primary"
          onClick={() => {
            setShowModal(true);
            window.history.pushState({}, "", "/");
          }}
        >
          {t("overview.loginn")}
        </button>
      </div>
    </div>
  );
}
